// @flow
import { commentsTransformer } from './comment';
import { operationsTransformer } from './operation';
import { Map } from 'immutable';

export const transformOneAnswer = (data: any) => {
	const metadataProperties = data.metadata ? data.metadata.properties : undefined;
	const votes =
		metadataProperties && metadataProperties.atl_cq_votes
			? metadataProperties.atl_cq_votes.value.total
			: 0;
	const result = {
		id: data.id,
		title: data.title,
		viewContent: data.body && data.body.view ? data.body.view.value : null,
		editorContent:
			data.body && data.body.atlas_doc_format ? data.body.atlas_doc_format.value : null,
		comments:
			data.children && data.children['comment']
				? commentsTransformer(data.children['comment'].results).results
				: [],
		votes,
		operations: data.operations ? operationsTransformer(data.operations) : Map({}),
		history: data.history ? data.history : {},
		author: data.history ? data.history.createdBy : {},
		version: data.version,
		container: data.container,
	};
	return result;
};

export const answersTransformer = (answers?: { results?: Array<any> } = { results: [] }) => {
	const { results } = answers;
	return {
		answers: (results && results.map(transformOneAnswer)) || [],
	};
};

export const answerTransformer = (answer: any) => transformOneAnswer(answer);

export const answerCountTransformer = (data: any) => {
	return { totalCount: data.totalSize };
};
